export const portfolioActionTypes = {
  ACTIVE_MARKETS_SUCCESS: "ACTIVE_MARKETS_SUCCESS",
  CLOSED_MARKETS_SUCCESS: "CLOSED_MARKETS_SUCCESS",
  ACTIVE_MARKETS_ERROR: "ACTIVE_MARKETS_ERROR",
  CLOSED_MARKETS_ERROR: "CLOSED_MARKETS_ERROR",
  CLOSED_MARKETS_SUCCESS_PROBE: "CLOSED_MARKETS_SUCCESS_PROBE",
  CLOSED_MARKETS_ERROR_PROBE: "CLOSED_MARKETS_ERROR_PROBE",
  SELECTED_CLOSED_PROBE: "SELECTED_CLOSED_PROBE",
  CLOSED_MARKETS_LOADING: "CLOSED_MARKETS_LOADING",
  ACTIVE_MARKETS_LOADING: "ACTIVE_MARKETS_LOADING",
  ACTIVE_MARKETS_SUCCESS1: "ACTIVE_MARKETS_SUCCESS1",
  ACTIVE_MARKETS_LIQUIDITY: "ACTIVE_MARKETS_LIQUIDITY",
  ACTIVE_MARKETS_SUCCESS_CONTEST: "ACTIVE_MARKETS_SUCCESS_CONTEST",
  ACTIVE_MARKETS_SUCCESS_CONTEST1: "ACTIVE_MARKETS_SUCCESS_CONTEST1",
};
